/**
 * Translation configuration for EventInfo type.
 * Defines which fields are translatable and how to extract them.
 */
import type { EventInfo } from '@/types/event';

import type { TranslationConfig } from '../core/types';

/**
 * Translation configuration for EventInfo.
 * Used by the bulk translation system for search results and event lists.
 */
export const eventTranslationConfig: TranslationConfig<EventInfo> = {
	name: 'event',
	getId: (event) => event.id,
	fields: [
		{
			key: 'name',
			extract: (event) => event.name,
		},
		{
			key: 'groupName',
			extract: (event) => event.groupName,
		},
		{
			key: 'address',
			extract: (event) => event.address,
		},
		{
			key: 'city',
			extract: (event) => event.city,
		},
		{
			key: 'state',
			extract: (event) => event.state,
		},
	],
};

/**
 * Field keys for EventInfo translation.
 * Use these constants instead of magic strings.
 */
export const EVENT_TRANSLATION_FIELDS = {
	NAME: 'name',
	GROUP_NAME: 'groupName',
	ADDRESS: 'address',
	CITY: 'city',
	STATE: 'state',
} as const;

export type EventTranslationFieldKey = (typeof EVENT_TRANSLATION_FIELDS)[keyof typeof EVENT_TRANSLATION_FIELDS];
